var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.itens),function(item,index){return _c('div',{key:index,class:`has-skeleton mb-${_vm.margin} py-${_vm.height}`})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }